import AnnonceListComponent from "./AnnonceListComponent";
const { Container } = require("reactstrap");

const AgentAnnonceList = () => {
  return (
    <div className="page-content">
      <Container fluid style={{ maxWidth: "100%" }}>
        <AnnonceListComponent />
      </Container>
    </div>
  );
};

export default AgentAnnonceList;
